import { Stack, Typography } from "@mui/material";

import { VehicleCard } from "@app/components";

import { ProductsListSectionsProps } from "../types";

const ProductListSection = ({
  title,
  items,
  selectedCardId,
  onSelect,
  onViewDetails,
}: ProductsListSectionsProps) => {
  return (
    <>
      <Stack px={8} py={4}>
        <Typography fontWeight={700} fontSize={25}>
          {title}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="flex-start"
        alignItems="center"
        gap={2}
        px={8}
      >
        {items?.map((item: any) => (
          <VehicleCard
            key={item?.id}
            vehicle={item}
            selectedCardId={selectedCardId}
            onSelect={() => onSelect(item?.id)}
            onViewDetails={onViewDetails}
          />
        ))}
      </Stack>
    </>
  );
};

export { ProductListSection };
